import { applyTokens } from "../../../utilities/applyTokens.js";
export const sizes = {
    small: "small",
    medium: "medium",
    large: "large",
    xLarge: "xlarge",
};
export const colors = {
    red: "red",
    yellow: "yellow",
    green: "green",
    blue: "blue",
    purple: "purple",
};
export const shapes = {
    circular: "circle",
    rounded: "square",
};
export const AvatarPresets = (tokens) => {
    const { component: { avatar }, semantic: { iconSize: iconSizes }, } = tokens;
    return {
        getAvatarProps: (size, shape, color) => {
            var _a;
            const sizeKey = size in sizes ? sizes[size] : "medium";
            const colorKey = color && color in colors ? colors[color] : undefined;
            const shapeKey = shape && shape in shapes ? shapes[shape] : "circle";
            const sizeTokens = avatar[sizeKey];
            const shapeTokens = sizeKey in avatar[shapeKey] ? avatar[shapeKey][sizeKey] : {};
            const colorTokens = colorKey ? avatar[colorKey] : {};
            const iconSizeKey = (_a = Object.entries(iconSizes).find(
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            ([_, { value }]) => value === sizeTokens.icon.width.value)) === null || _a === void 0 ? void 0 : _a[0];
            return {
                variant: shape,
                sx: Object.assign(Object.assign(Object.assign(Object.assign({}, applyTokens(sizeTokens)), applyTokens(shapeTokens)), applyTokens(colorTokens)), (iconSizeKey && {
                    "--atlas-icon-size": iconSizeKey,
                })),
            };
        },
    };
};
//# sourceMappingURL=avatar.js.map